import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23bbe0ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "card-body heading-small text-muted mb-4" }, "Custom Field", -1))
const _hoisted_3 = { class: "card-body col text-right" }
const _hoisted_4 = { class: "px-lg-4 row" }
const _hoisted_5 = { class: "col-lg-12" }
const _hoisted_6 = {
  class: "d-flex justify-content-end mb-2",
  style: {"display":"none !important"}
}
const _hoisted_7 = { class: "form-group d-flex" }
const _hoisted_8 = { class: "mr-2 w-20" }
const _hoisted_9 = {
  key: 0,
  class: "form-control-label",
  for: "cf-label"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ni ni-fat-remove" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "card-body text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { style: {"color":"#8898ab"} }, "Empty Custom Field", -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_n_input = _resolveComponent("n-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.viewOnly)
        ? (_openBlock(), _createBlock(_component_n_button, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRow($event))),
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" + Add ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue?.value, (model, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_n_checkbox, {
              disabled: _ctx.viewOnly,
              checked: _ctx.modelValue.value[index].table,
              "onUpdate:checked": ($event: any) => ((_ctx.modelValue.value[index].table) = $event)
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Show on Table ")
              ]),
              _: 2
            }, 1032, ["disabled", "checked", "onUpdate:checked"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.viewOnly)
                ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(model.label), 1))
                : _createCommentVNode("", true),
              (!_ctx.viewOnly)
                ? (_openBlock(), _createBlock(_component_n_input, {
                    key: 1,
                    id: "cf-label",
                    value: _ctx.modelValue.value[index].label,
                    "onUpdate:value": ($event: any) => ((_ctx.modelValue.value[index].label) = $event),
                    type: "text",
                    size: "large",
                    placeholder: "Label"
                  }, null, 8, ["value", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_n_input, {
              class: "w-55",
              id: "cf-label",
              value: _ctx.modelValue.value[index].value,
              "onUpdate:value": ($event: any) => ((_ctx.modelValue.value[index].value) = $event),
              disabled: _ctx.viewOnly,
              type: "text",
              size: "large",
              placeholder: "Value"
            }, null, 8, ["value", "onUpdate:value", "disabled"]),
            (!_ctx.viewOnly)
              ? (_openBlock(), _createBlock(_component_n_button, {
                  key: 0,
                  class: "ml-2 w-5",
                  onClick: ($event: any) => (_ctx.removeRow(index, $event)),
                  size: "large",
                  type: "error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 256)),
      (!_ctx.modelValue || _ctx.modelValue?.value?.length < 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
        : _createCommentVNode("", true)
    ])
  ]))
}